<template>
    <div class="o-modal-base modal-base">
        <div class="modal-base__overlay" @click.self="closeOutsideModal"/>
        <div class="modal-base__slot">
            <component
                v-model="modalData"
                :is="defineComponent"
                :obj="data"
                @onClose="closeModal"
            />
        </div>
    </div>
</template>

<script>
import OSmsModal from '../../unique-organisms/o-sms-modal/o-sms-modal';
import OSupportModal from '../../unique-organisms/o-support-modal/o-support-modal';
import OServicesModal from '../../unique-organisms/o-services-modal/o-services-modal';
import ORotateDeviceModal from '../../organisms/o-rotate-device-modal/o-rotate-device-modal';
import ONotificationModal from '../../unique-organisms/o-notification-modal/o-notification-modal';

export default {
    name: 'OModalBase',
    data() {
        return {
            modalData: 0,
            componentsMap: {
                sms: 'OSmsModal',
                support: 'OSupportModal',
                services: 'OServicesModal',
                notification: 'ONotificationModal',
                rotateDevice: 'ORotateDeviceModal'
            }
        }
    },
    props: {
        organism: {
            type: String,
            required: true
        },
        data: {
            type: Object,
            default: () => {}
        },
        clickOutside: {
            type: Boolean,
            default: true
        }
    },
    components: {
        OSmsModal,
        OSupportModal,
        OServicesModal,
        ONotificationModal,
        ORotateDeviceModal
    },
    computed: {
        defineComponent() {
            return this.componentsMap[this.organism];
        }
    },
    methods: {
        closeModal() {
            this.$emit('onClose', true)
        },
        closeOutsideModal() {
            if (this.clickOutside) this.closeModal();
        }
    }
}
</script>

<style lang="scss">
@import "o-modal-base";
</style>
